<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Sistema di emissione"
        v-model="implant.emission_system"
        :options="['Radiatori', 'Termoconvettori', 'Ventilconvettori', 'Pannelli radianti', 'Bocchette', 'Strisce radianti', 'Travi fredde', 'Altro']"
        multiple
      />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="isOther">
      <InputTextarea name="Descrizione altro sistema" v-model="implant.emission_system_description" />
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    implant: Object
  },
  emits: ['update:implant'],

  computed: {
    isOther() {
      return this.implant.emission_system?.includes('Altro')
    },
  },

  methods: {
    
  }
}
</script>